// import { h } from 'preact';
// import style from './style';
// import YouTube from 'react-youtube';
// const Home = () => (
// 	<div class="block">
//     <br/>
//     <br/>    <br/>
//   <div class="songItem">
//   <a class="apple" target="_blank" href=" https://music.apple.com/us/album/shake-the-snow-globe/1489508511">
//     apple music
//     </a>

//     <img src="/assets/cover.jpg"/>

//     {/* <a class="apple" href="https://asf.is/blanks/apple">
//     apple music
//     </a> */}

   
   
//     </div>
//     {/* <div class="videoWrapper">
//     <YouTube
//         videoId="gs-nTdWrOB0"
//       />
// 	</div> */}


//   </div>
// );
// export default Home;

import { h, Component } from 'preact';

import Product from '../shop/components/Product';
import _ from 'lodash'

import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

class Home extends Component {
  componentWillReceiveProps = (nextProps) => {
    if (!_.isEqual(this.props.data.shop, nextProps.data.shop) &&
      nextProps.data && nextProps.data.shop &&
      nextProps.data.shop.collections.edges[0].node.products &&
      nextProps.data.shop.collections.edges[0].node.products.pageInfo.hasNextPage
    ) {
      const length = nextProps.data.shop.collections.edges[0].node.products.edges.length
      const lastItem = nextProps.data.shop.collections.edges[0].node.products.edges[length - 1]

      nextProps.data.fetchMore({
        variables: {
          after: this.cursor || lastItem.cursor,
        },
        updateQuery: (prev, { fetchMoreResult, ...rest }) => {
          if (!fetchMoreResult) return prev;
          const length = fetchMoreResult.shop.collections.edges[0].node.products.edges.length
          const lastItem = fetchMoreResult.shop.collections.edges[0].node.products.edges[length - 1]
          if (lastItem) {
            this.cursor = lastItem.cursor
          } else {
            this.cursor = null
          }
          
          return {
            ...fetchMoreResult,
            shop: {
              ...fetchMoreResult.shop,
              collections: {
                ...fetchMoreResult.shop.collections,
                edges: [
                  {
                    ...fetchMoreResult.shop.collections.edges[0],
                    node: {
                      ...fetchMoreResult.shop.collections.edges[0].node,
                      products: {
                        ...fetchMoreResult.shop.collections.edges[0].node.products,
                        edges: [
                          ...prev.shop.collections.edges[0].node.products.edges,
                          ...fetchMoreResult.shop.collections.edges[0].node.products.edges
                        ]
                      },
                    }
                  }
                ]
              }
            },
          };
        }
      })
    }
  }
  render() {
    // if (this.props.data.loading) {
    //   return <p class="fixed">loading shop</p>;
    // }
    if (this.props.data.error) {
      return <p>{this.props.data.error.message}</p>;
    }

    let data = this.props.data

    if (data.shop && data.shop.collections) {
      data = {
        ...data,
        shop: {
          ...data.shop,
          products: data.shop.collections.edges[0].node.products
        }
      }
    } else {
      data = {
        ...data,
        shop: {
          ...data.shop,
          products: {
            edges: []
          }
        }
      }
    }
// console.log(data.shop.products.edges)
    return (
      <div className="App">
        {/* {this.props.isHome && <Home />} */}

     
        <div className="Product-wrapper shopPage faded">

<br />
          {data.shop.products.edges.map(product =>
            <Product addVariantToCart={this.props.addVariantToCart} checkout={this.props.checkout} key={"shop-page-"+product.node.id.toString()} product={product.node} />
          )}
        </div>
      </div>
    );
  }
}

const queryCollection = gql`
  query query($after: String) {
    shop {
      name
      collections(first:1, query:"title:beta"){
        edges{
          node{
            products(first:10, after: $after, sortKey: MANUAL) {
              pageInfo {
                hasNextPage
                hasPreviousPage
              }
              edges {
                cursor
                node {
                  availableForSale 
                  description
                  id
                  title
                  handle
                  tags
                  options {
                    id
                    name
                    values
                  }
                  variants(first: 250) {
                    pageInfo {
                      hasNextPage
                      hasPreviousPage
                    }
                    edges {
                      node {
                        availableForSale
                        id
                        title
                        selectedOptions {
                          name
                          value
                        }
                        image(maxWidth: 500) {
                          src: transformedSrc(maxWidth: 500)
                          gallery: transformedSrc(maxWidth: 800)
                          zoom: transformedSrc(maxWidth: 1000)
                        }
                        price
                      }
                    }
                  }
                  images(first: 250, maxWidth: 500) {
                    pageInfo {
                      hasNextPage
                      hasPreviousPage
                    }
                    edges {
                      node {
                        src: transformedSrc(maxWidth: 500)
                        gallery: transformedSrc(maxWidth: 800)
                        zoom: transformedSrc(maxWidth: 1000)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const HomeWithData = compose(
  graphql(queryCollection, {
    props: props => {
      let data = props.data

      if (data.shop && data.shop.collections) {
        data = {
          ...data,
          shop: {
            ...data.shop,
            products: [
              data.shop.collections.edges[0].node.products
            ]
          }
        }
      } else {
        data = {
          ...data,
          shop: {
            ...data.shop,
            products: {
              edges: []
            }
          }
        }
      }

      return ({
        ...props,
        data
      })
    }
  })
)(Home);

export default HomeWithData;



// WEBPACK FOOTER //
// ./routes/home/index.js